import Vue from "vue";
import VueRouter from "vue-router";

import layout from "@/layout";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    redirect: "/home/index",
    name: "home",
    component: layout,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "index",
        name: "homeIndex",
        component: () => import("@/views/home"),
        meta: {
          breadcrumb: false,
          title: "首页",
        },
      },
      {
        path: "/course-info/index",
        name: "courseInfo",
        component: () => import("@/views/course-info/index"),
        meta: {
          title: "课程详情",
        },
      },
      {
        path: "/search/index",
        name: "search",
        component: () => import("@/views/search/index"),
        meta: {
          title: "搜索结果",
        },
      },
      // {
      //   path: '/search/index',
      //   name: 'search',
      //   component: () => import('@/views/search/index')
      // },
      {
        path: "/knowledge/index",
        name: "knowledge",
        component: () => import("@/views/knowledge/index"),
        meta: {
          title: "知识库列表",
        },
      },

      {
        path: "/classify/index",
        name: "classify",
        component: () => import("@/views/classify/index"),
        meta: {
          title: "课程列表",
        },
      },
      {
        path: "/message/index",
        name: "message",
        component: () => import("@/views/message/index"),
        meta: {
          title: "消息列表",
        },
      },
      {
        path: "/user/index",
        name: "user",
        component: () => import("@/views/user/index"),
        meta: {
          title: "个人中心",
        },
      },
      {
        path: "/records",
        name: "records",
        component: () => import("@/views/records/index"),
        meta: {
          title: "浏览记录",
        },
      },
    ],
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
  },
  {
    path: "/knowledge/info",
    name: "knowledgeInfo",
    component: () => import("@/views/knowledge/info"),
    meta: {
      title: "知识库详情",
    },
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

// const blacks = ["user", "knowledgeInfo", "knowledge", "message"];
const blacks = [];

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem("token");
  // if (blacks.includes(to.name)) {
  //   if (token) {
  //     await store.dispatch("setToken", localStorage.getItem("token"));
  //     await store.dispatch(
  //       "setUserInfo",
  //       JSON.parse(localStorage.getItem("userInfo") || "{}")
  //     );
  //     return next();
  //   }
  //   if (!token) return next("/login");
  // } else {
  //   next();
  // }

  if (token) {
    await store.dispatch("setToken", localStorage.getItem("token"));
    await store.dispatch(
      "setUserInfo",
      JSON.parse(localStorage.getItem("userInfo") || "{}")
    );
    next();
  } else {
    if (to.name === "login") {
      next();
    } else {
      next("/login");
    }
  }
  // if (blacks.includes(to.name)) {
  //   if (token) {
  //     // next();
  //   } else {
  //     next("/login");
  //   }
  // }
});

// router.beforeEach(async (to, from, next) => {

//   // console.log(from, to);
//   if (localStorage.getItem("token")) {
//     await store.dispatch("setToken", localStorage.getItem("token"));
//     await store.dispatch(
//       "setUserInfo",
//       JSON.parse(localStorage.getItem("userInfo") || "{}")
//     );
//   } else {
//     // next("/");
//   }

//   // console.log(blacks.indexOf(to.name));
//   if (blacks.indexOf(to.name) < 0) {
//     next();
//   } else {
//     if (!localStorage.getItem("token")) {
//       next("/");
//     } else {
//       next();
//     }
//   }
// });

export default router;
